import { useCallback, useEffect, useState } from 'react';
import { BACKEND_URL } from './apiConfig';
import { authFetch } from './authHelpers';
import { leesJson } from './apiFout';
import { normalizeCapacityRules, DEFAULT_CAPACITY_RULES } from './capacityCalc';

/**
 * De actieve capaciteitsregels (standaard + wat de planner heeft aangepast).
 *
 * Elke pagina die bezetting toont rekent hiermee, zodat Planner To-Do, Capaciteit
 * en de uitleg-panelen nooit uit elkaar lopen. Fail-soft: gaat de call stuk, dan
 * rekenen we door met de ingebouwde standaard i.p.v. een lege pagina te tonen.
 */
export function useCapacityRules() {
  const [rules, setRules] = useState(DEFAULT_CAPACITY_RULES);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // leesbare fout; de schermen kiezen zelf hoe ze die tonen

  const reload = useCallback(async () => {
    try {
      const r = await authFetch(`${BACKEND_URL}/Api/planning-rules`);
      const d = await leesJson(r, 'Capaciteitsregels laden');
      setRules(normalizeCapacityRules(d.rules));
      setError(null);
    } catch (e) {
      // Niet stil: fail-soft met de standaardregels, maar wél zichtbaar in de console + error-state.
      console.warn('[useCapacityRules]', e.message);
      setError(e.message);
      setRules(DEFAULT_CAPACITY_RULES);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { rules, loading, error, reload, setRules };
}
